import React, { Component } from "react";
import { Card } from "@deere/ux.uxframe-react";

class SupplierInfoLeftHeader extends Component {
    render() {
        return (
            <div>
                <Card>
                    <div class="card-body">
                        <div class="text-xs-left">
                            <label class="uxf-label">Company Name</label>
                            <p class="uxf-label" style={{ fontWeight: 'normal' }}>{this.props.companyInfoObj.companyName}</p>
                        </div>
                        <div class="text-xs-left">
                            <label class="uxf-label">Parent Company Name</label>
                            <p class="uxf-label" style={{ fontWeight: 'normal' }}>{this.props.companyInfoObj.parentCoName}</p>
                        </div>
                        <div class="text-xs-left">
                            <label class="uxf-label">WebSite URL</label>
                            <p class="uxf-label" style={{ fontWeight: 'normal' }}><a href="#">{this.props.companyInfoObj.websiteUrl}</a></p>
                        </div>
                        <div class="text-xs-left">
                            <label class="uxf-label">Address</label>
                            <p class="uxf-label" style={{ fontWeight: 'normal' }}>
                                {this.props.companyInfoObj.address}<br></br>
                                {this.props.companyInfoObj.stateName === null || this.props.companyInfoObj.stateName === "" ? "" :<span>{this.props.companyInfoObj.stateName},&nbsp;</span>}{this.props.companyInfoObj.zip}<br></br>
                                {this.props.companyInfoObj.countryName}
                            </p>
                        </div>
                        <div class="text-xs-left">
                            <label class="uxf-label">Telephone</label>
                            <p class="uxf-label" style={{ fontWeight: 'normal' }}>{this.props.companyInfoObj.phone}</p>
                        </div>
                        <div class="text-xs-left">
                            <label class="uxf-label">Key Contact</label>
                            <p class="uxf-label" style={{ fontWeight: 'normal' }}>
                                {this.props.companyInfoObj.contactName}<br></br>
                                {this.props.companyInfoObj.jobTitle}<br></br>
                                <a href="#">{this.props.companyInfoObj.emailAddress}</a>
                            </p>
                        </div>
                    </div>
                </Card>
            </div>
        )
    }
}
export default SupplierInfoLeftHeader;